import { BatchScopePicker } from "./BatchScopePicker";
import { ReportsTab } from "./batch-detail/ReportsTab";

export function ReportsGlobalPage() {
  return (
    <BatchScopePicker title="Reports">{(batch) => <ReportsTab batch={batch} />}</BatchScopePicker>
  );
}
